import { render } from "./GitCheatSheet.vue?vue&type=template&id=34ed7a72&scoped=true"
const script = {}

import "./GitCheatSheet.vue?vue&type=style&index=0&id=34ed7a72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ed7a72"]])

export default __exports__